module.exports = __webpack_public_path__ + "static/Q6Answer1_Peoplenotfollowingrules_RyanFranco-8d32cd57a0bc9b03f3bd806d2cee0945.jpg";